import { ReactElement } from 'react'
import { useControlStore } from '@editorStores'
import { useGetPlanSettings } from '@editorHooks'
import PlanAreaFrameLines from './PlanAreaFrameLines'
import { selectPreviewedPlanSettings } from './selectPreviewedPlanSettings'

/**
 * Plan area frame of the saved plan settings. Steps aside while a plan settings form previews its
 * unsaved values in the scene (a `PlanAreaFrameLines` scene element, see
 * `usePlanSettingsScenePreview`), so only the previewed frame is drawn.
 */
const PlanAreaFrame = (): ReactElement | null => {
  const { data: planSettings } = useGetPlanSettings()
  const previewedPlanSettings = useControlStore(selectPreviewedPlanSettings)

  if (previewedPlanSettings) return null

  return <PlanAreaFrameLines planSettings={planSettings} />
}

export default PlanAreaFrame
